import React, { useEffect } from 'react'
import { TextField, Grid, Box, Button } from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { FreeRideTwoSchema } from '../../Utils/Validations'
import PhoneInput from 'react-phone-input-2'
const RideFormTwo = ({ handleBack, handleComplete, freeRideData, setFreeRideData }) => {
  const { handleSubmit, control, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(FreeRideTwoSchema)
  })

  useEffect(() => {
    setValue("phone", freeRideData.phone || "")
    setValue("patient_name", freeRideData.patient_name || "")
  }, [])
  const onSubmit = (data) => {
    console.log(data)
    setFreeRideData((prev) => ({ ...prev, phone: `+${data.phone}`, patient_name: data.patient_name }))
    handleComplete()
  }

  return (
    <div>

      <Grid container style={{ justifyContent: "center", marginTop: 20 }} >
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 } }} >
          <Controller
            control={control}
            name="phone"
            rules={{ required: true }}
            render={({ field:{value,onChange} }) => (
              <>
              <label>Phone Number</label>
                <PhoneInput disableCountryCode onlyCountries={["us"]} country={"us"} placeholder='Enter your 10 digit phone number' value={value} onChange={(p)=>onChange(p)} />
              { errors.phone? <p className='error-message' > {errors?.phone?.message}</p>:null}
              </>
            )}

          />


        </Grid>
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingLeft: { sm: 1, xs: 0 }, marginTop: { sm: 0, xs: 2 } }} >
          <Controller
            control={control}
            name="patient_name"
            rules={{ required: true }}
            render={({ field }) => (
              <>
                <label>Patient's Name</label>
                <TextField fullWidth placeholder="Patient's Name" {...field} error={errors.patient_name} helperText={errors?.patient_name?.message} />

              </>
            )}

          />

        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{minWidth:"10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{minWidth:"10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={handleSubmit(onSubmit)}>


          Next
        </Button>

      </Box>
    </div>
  )
}

export default RideFormTwo